export type TPageType = 'smb' | 'sob' | 'host';

export enum EDealType {
  Sale = 'sale',
  Rent = 'rent',
}

export enum EOfferType {
  Apartment = 'apartment',
  Suburban = 'suburban',
}

export type TWantType = {
  id: EDealType;
  text: string;
  imgClass: string;
};
